/*
 * @Author: zhoulang zhoulang@kuaishou.com
 * @Date: 2025-02-08 15:35:12
 * @LastEditors: zhoulang zhoulang@kuaishou.com
 * @LastEditTime: 2025-02-08 15:40:21
 * @FilePath: /kibt-fe-shop-c-outside/client/component/SeoContainer/index.tsx
 * @Description: 站外SEO pc端容器组件，包裹页面根组件进行居中适配
 */
import { isMobileDevice, isWeb } from '@/common/device-info';
import React, { useEffect } from 'react';
import { View } from 'react-native';

export const useAutoSetWidth = () => {
    const [width, setWidth] = React.useState(414);

    const setRemUnit = () => {
        const docEl = document.documentElement;
        console.log(docEl.clientWidth, 'docEl.clientWidth:::::');
        if (docEl.clientWidth >= 1920) {
            setWidth(414 * 1.2);
        } else {
            setWidth(414);
        }
    };

    useEffect(() => {
        setRemUnit();
        // 添加事件监听器
        window.addEventListener('resize', setRemUnit);
        window.addEventListener('pageshow', e => {
            if (e.persisted) {
                setRemUnit();
            }
        });

        // 在组件卸载时移除事件监听器
        return () => {
            window.removeEventListener('resize', setRemUnit);
            window.removeEventListener('pageshow', setRemUnit);
        };
    }, []);

    return {
        width,
    };
};

const SeoContainer = ({ children }) => {
    const { width: _containerWidth } = useAutoSetWidth();

    if (!isWeb) {
        return children;
    }

    if (isMobileDevice()) {
        return children;
    }

    return (
        <View style={{"backgroundColor":"rgba(0, 0, 0, 1)","height":"100vh","overflow":"hidden"}}>
            <View style={{ width: _containerWidth, margin: 'auto', backgroundColor: '#fff', height: '100vh' }}>{children}</View>;
        </View>
    );
};

export default SeoContainer;
